import FetchError from './FetchError';

export default class UnauthorizedError extends FetchError {
  constructor(message: string = 'Unauthorized') {
    super(message, 401);
  }
}
